import { render, staticRenderFns } from "./SendRegisterForm.vue?vue&type=template&id=149462fe"
import script from "./SendRegisterForm.vue?vue&type=script&lang=js"
export * from "./SendRegisterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports